module.exports = __webpack_public_path__ + "img/product1.09335532.png";